/* eslint-disable no-unused-vars */
<template>
  <router-view></router-view>
</template>

<script lang="ts">
import { defineComponent } from "vue"; //, inject, onMounted, ref } from "vue";

export default defineComponent({
	name: "App",
});
</script>

<style lang="scss">
</style>
